import assets, {
  AddCircle,
  createNew,
  recentIcon,
  templateIcon,
  themeIcon,
  imageIcon,
  userProfileIcon,
  Clock,
  Close,
  List,
  List2,
  Logout,
  profileIcon,
  UserProfile,
  BusinessListIcon,
  UserList,
  HomeBold,
  reportIcon,
} from "assets";
// import crownIcon from "../../assets/images/crown-img.png"
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./styles.scss";
import { PermissionType, RouteType } from "routes/config";
import userRoutes, { agencyRoutes, superAdminRoutes } from "routes/appRoutes";
import { useAppDispatch, useTypedSelector } from "redux/store";
import { IconReport } from "@tabler/icons-react";
import {
  logoutStore,
  selectDashboardSidebarClickCount,
  selectIsAgencyRole,
  selectIsMarketerRole,
  selectIsMobileView,
  selectIsShowSidebar,
  selectIsSuperAdminRole,
  selectPermissions,
  updateDashboardSidebarClickCount,
  updateIsShowSidebar,
} from "redux/features/appStateSlice";
import {
  getCampaignMediumStore,
  getCampaignSupportStore,
  getCampaignTypeStore,
  resetCampaignFormState,
  resetCampaignOprationState,
  restartContentDetailsState,
} from "redux/features/campaignOprationalSlice";
import { Dropdown } from "react-bootstrap";
import React, { useState, useRef, useEffect, useMemo } from "react";
import Confirmation from "./confirmation";
import { resetBussinessList } from "../../redux/features/bussinessListSlice";
import { resetCampaignList } from "../../redux/features/campaignSlice";
import { resetNotification } from "../../redux/features/notificationSlice";
import { resetPR } from "../../redux/features/pressReleaseSlice";
import { resetUserList } from "../../redux/features/userSlice";
import humetaLogo from "../../assets/svg/humeta_logo.svg";
import SidebarHistory from "./SidebarHistory/SidebarHistory";
import { getFromStore, getUser } from "../../helpers/storage";
import { useAuth } from "../../hooks/useAuth";
import { useSelector } from "react-redux";
import {
  selectLogo,
  selectSmallLogo,
  setSmallLogo,
} from "redux/features/logoSlice";
import { Auth } from "../../types/Auth";
import { contentTypeService } from "../../services";
import { ContentCreationSlugs } from "../../types/content-creation";
import { setContentTypeState } from "../../redux/features/contentTypeSlice";
import { toastError } from "../../helpers/toastHelper";



const CustomDropdown = ({
  isSuperAdminRole,
  onClickProfile,
  setConfirmationShow,
  showName,
  children,            
}: {
  isSuperAdminRole: any;
  onClickProfile: any;
  setConfirmationShow: any;
  showName: boolean;
  children?: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const { user } = useAuth();

  const toggleDropdown = (e?: React.MouseEvent) => {
    e?.stopPropagation?.();
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleOutside = (event: MouseEvent) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleOutside);
    return () => document.removeEventListener("click", handleOutside);
  }, []);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setIsOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`dropDown ${showName ? "dropdownContentLeft" : ""}`}
    >
      <div onClick={toggleDropdown} className="dropdown-trigger" role="button" aria-haspopup="menu" aria-expanded={isOpen}>
        {children ? (
          children
        ) : (
          <img src={assets.images.profileImg} alt="User" className="icon-circle" />
        )}
      </div>

      {isOpen && (
        <div className={`dropDownMenu ${showName ? "dropDownMenuFullName" : ""}`} role="menu">
          {!isSuperAdminRole && (
            <div className="dropDownItem" onClick={() => onClickProfile()}>
              <img src={UserProfile} alt="UserProfile" className="menu-icon" />
              <span>View Profile</span>
            </div>
          )}
          <div
            className="dropDownItem"
            onClick={() => {
              setIsOpen(false);
              setConfirmationShow(true);
            }}
          >
            <img src={Logout} alt="Logout" className="menu-icon" />
            <span>Logout</span>
          </div>
        </div>
      )}

      {showName && (
        <p className="userName">
          {user?.firstName} {user?.lastName}
        </p>
      )}
    </div>
  );
};


const Sidebar = () => {
  const isSuperAdminRole = useTypedSelector(selectIsSuperAdminRole);
  // const isAgencyRole = useTypedSelector(selectIsAgencyRole);
  const isMarketerRole = useTypedSelector(selectIsMarketerRole);
  const count = useTypedSelector(selectDashboardSidebarClickCount);
  const isShowSidebar = useTypedSelector(selectIsShowSidebar);
  const isMobileView = useTypedSelector(selectIsMobileView);
  const permissions = useTypedSelector(selectPermissions);
  const [confirmationShow, setConfirmationShow] = useState<boolean>(false);
  // const [showHistory, setShowHistory] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const isNewAgencyFlow = getFromStore("isNewAgencyFlow");
  
  const {selectedContentType,isLoading,isChatRunning} = useSelector((state:any) => state.contentTypeState);
const [typeConfirm, setTypeConfirm] = useState<null | { open: boolean; item: any }>(null);
  const isAgencyAdmin = user?.roleId === Auth.UserProfileRole.Agency

const isAgentUserOrAdmin = (isAgencyAdmin || isNewAgencyFlow)
  const [contentTypes, setContentTypes] = useState([]);
  const getContentTypes = async () => {
    const { data } = await contentTypeService.getContentType({
      filter: {
        slug: Object.values(ContentCreationSlugs)
         .filter(
          (val: ContentCreationSlugs) => {
            if (!isAgentUserOrAdmin) return val;
            else{
              return val !== ContentCreationSlugs.SCIENTIFICLBL && val !== ContentCreationSlugs.VISUALAID && val !== ContentCreationSlugs.MARKETINGEMAILER
            }
          }
        ),
      },
    })
    setContentTypes(data.filter((ct:any)=> isAgentUserOrAdmin ?  ct.isEnabled :true))
  }

  useEffect(() => {
    getContentTypes()
  }, [])

  const onClickNav = (index = 0) => {
    if (index === 0)
      dispatch(updateDashboardSidebarClickCount(Number(count) + 1));
    if (
      location?.pathname?.includes("campaign/create") ||
      location?.pathname?.includes("campaign/update")
    ) {
      dispatch(resetCampaignFormState());
      dispatch(resetCampaignOprationState());
      dispatch(restartContentDetailsState({}));
      dispatch(getCampaignTypeStore({}));
      dispatch(getCampaignMediumStore({}));
      dispatch(getCampaignSupportStore({}));
    }
    setSidebar(!isShowSidebar);
  };

  const setSidebar = (show = false) => {
    dispatch(updateIsShowSidebar({ show }));
  };

  const reloadPage = (path: string = "") => {
    if (!path) return;
    return (
      location?.pathname?.includes("campaign/update") &&
      path?.includes("campaign/create")
    );
  };

  const renderSideRoute = (routes: RouteType[] = []) => {
    if (!routes || !routes.length) return "";
    return routes.map((route: RouteType, index: number) => (
      <li
        key={route.path}
        className={`${!isSuperAdminRole ? "client_common" : ""} ${
          !!location?.pathname?.includes(route.path)
            ? !!isSuperAdminRole
              ? "active-adminSidebar"
              : "active-clientSidebar"
            : !isSuperAdminRole
            ? "client_li"
            : "admin_li"
        }`}
      >
        <Link
          className={!!isSuperAdminRole ? "admin_content" : "client_content"}
          to={route.path}
          onClick={() => onClickNav(index)}
          reloadDocument={reloadPage(route.path)}
        >
          <span
            className={
              !isSuperAdminRole ? "client_route-img" : "admin_route-img"
            }
          >
            {route.sidebarProps?.img}
          </span>
          {route.sidebarProps?.displayText}
        </Link>
      </li>
    ));
  };

  const getAdminUserSidebar = (
    routesArr: RouteType[] = [],
    permissionArr: PermissionType[] = []
  ) => {
    return routesArr?.filter((route: RouteType) => {
      return permissionArr?.some(
        (permission: PermissionType) =>
          permission?.module === route?.state && permission?.is_show
      );
    });
  };
  const onClickProfile = () => {
    navigate("/account-settings");
  };
  const userToggle = React.forwardRef<
    HTMLImageElement,
    {
      children: React.ReactNode;
      onClick: (e: React.MouseEvent<HTMLImageElement>) => void;
    }
  >(({ children, onClick }, ref) => (
    <>
      <img
        className="icon-circle"
        src={profileIcon}
        ref={ref}
        alt="Profile Img"
        // width="30"
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      />
    </>
  ));

  const cleanAllState = () => {
    dispatch(resetBussinessList());
    dispatch(resetCampaignOprationState());
    dispatch(resetCampaignList());
    dispatch(resetNotification());
    dispatch(resetPR());
    dispatch(resetUserList());
    dispatch(resetNotification());
  };

  const onClickLogout = async () => {
    await dispatch(logoutStore());
    cleanAllState();
    navigate(`${isNewAgencyFlow ? "/aristo" : "/login"}`, {
      replace: true,
    });
  };

  useEffect(() => {
    console.log(confirmationShow);
  }, [confirmationShow]);
  const showConfirmation = useMemo(() => {
    if (!confirmationShow) return;
    return (
      <Confirmation
        show={confirmationShow}
        onHide={() => {
          setConfirmationShow(false);
        }}
        onConfirmation={() => {
          if (confirmationShow) onClickLogout();
        }}
        title={confirmationShow ? "Logout Confirmation" : "Delete Notification"}
        description={`Are you sure you want to ${
          confirmationShow ? "logout" : "delete this notification"
        }?`}
        actionBtnName="Yes"
        actionBtnColor="white"
        actionBtnBgColor="#00b8c2"
      />
    );
  }, [confirmationShow]);

  const logoUrl = useSelector(selectLogo);
  const smallLogo = useSelector(selectSmallLogo);

  function handleContentTypeClick(ct: any) {
    if (ct?.contentTypeId) {
      navigate(`/manage-content/add-new-manage-content?contentTypeId=${ct.contentTypeId}`);
    }
    setTypeConfirm(null);
  }


  return (
    <>
      {!!isSuperAdminRole && (
        <div
          className={`sidebar ${!!isSuperAdminRole ? "roleOne" : "roleTwo"} ${
            isShowSidebar && isMobileView
              ? "roleTwo-left0"
              : isMobileView
              ? "roleTwo-left-m-100"
              : ""
          }`}
        >
          {isMobileView && (
            <Link to="#" className="closeIcon">
              <img
                src={Close}
                alt="Close"
                onClick={() => setSidebar(!isShowSidebar)}
                width={24}
              />
            </Link>
          )}

          <ul className={!isSuperAdminRole ? "client_logo-ui" : ""}>
            <li className={!isSuperAdminRole ? "client_logo-li" : "admin_li"}>
              <Link to="/">
                <img
                  src={
                    !!isSuperAdminRole
                      ? assets.images.grayLogo
                      : assets.images.shotLogoNew
                  }
                  alt="Logo"
                  width=""
                  className={
                    !!isSuperAdminRole ? "logo-image" : "client_logo-image"
                  }
                />
              </Link>
            </li>
            {renderSideRoute(
              isSuperAdminRole
                ? getAdminUserSidebar(superAdminRoutes, permissions)
                : true
                ? agencyRoutes
                : userRoutes
            )}
          </ul>
        </div>
      )}
{!isSuperAdminRole && (
  <div
    id="client-sidebar"
    className={`sidebar1 ${isShowSidebar ? "open" : "closed"}`}
    role="complementary"
    aria-hidden={!isShowSidebar}
    aria-expanded={isShowSidebar}
  >
            <div className="titleSection">
              <Link
                to={
                  user?.roleId === Auth.UserProfileRole.Agency
                    ? "/agency-dashboard"
                    : "/manage-content/add-new-manage-content"
                }
                className="client_logo-ui"
              >
                <img
                  src={logoUrl}
                  alt="Logo"
                  width=""
                  className={"client_logo-image-large"}
                />
                {/* <div className="borderBottom"></div> */}
              </Link>
            </div>
            <div>
             
            </div>
              <div className="mainSection">
                {isAgencyAdmin && 
                  <div>
                <div className="blue-heading">
                <p>Manage</p>
              </div>
<div className="lowerSection">
                {/* <img src={assets.images.clockImg} className="icon-circle" /> */}
                {/* {!user?.agentDetails && (
                  <>
                    <div>
                      <img
                        src={assets.images.whatsappImg}
                        className="icon-circle"
                      />
                    </div>

                    <div>
                      <img
                        src={assets.images.crownImg}
                        onClick={() => {
                          navigate("/credits-subscriptions");
                        }}
                        className="icon-circle"
                      />
                    </div>
                  </>
                )} */}
                <div
                  className="flex"
                  onClick={()=>{
                      navigate("/agency-dashboard")
                    }}
                >
                   <img src={HomeBold} alt="Campaigns"
                    className="icon-circle"
                    
                  />
                  <span>Dashboard</span>
                </div>
                <div
                  className="flex"
                   onClick={()=>{
                      navigate("/manage-content/user-list")
                    }}
                >
                   <img src={UserList} alt="Campaigns"
                    className="icon-circle"
                   
                  />
                  <span>User List</span>
                </div>
                <div
                  className="flex"
                  onClick={()=>{
                      navigate("/manage-content/doctor-report")
                    }}
                >
                   <img 
                    src={reportIcon} 
                    alt="Campaigns"
                    className="icon-circle"
                    
                  />
                  <span>Doctor Report</span>
                </div>
                </div>
              </div>}
              <div className="blue-heading">
                <p>Projects</p>
              </div>
              <div className="upperSection">
                <div
                className="flex"
                onClick={() => {
                  navigate("/manage-content/add-new-manage-content", {
                    state: { reset: true },
                  });
                }}
                >
                  <img
                    src={createNew}
                    alt="Campaigns"
                    className="icon-circle"
                  />
                  <span>Create New</span>
                </div>
                {
                  !isAgencyAdmin &&
                  <div className="submenus">
              {contentTypes.map((val: any) => (
                <span
                  key={val.contentTypeId}
                  onClick={() => {
                    if (!val.isEnabled) {
                      toastError("This content type is not available right now.");
                      return;
                    }
                    if(isLoading || isChatRunning){
                      setTypeConfirm({ open: true, item: val });
                    }else{
                      handleContentTypeClick(val);
                    }
                  }}
                  className={selectedContentType?.contentTypeId === val.contentTypeId ? "selected" : ""}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      if (!val.isEnabled) {
                        toastError("This content type is not available right now.");
                        return;
                      }
                      setTypeConfirm({ open: true, item: val });
                    }
                  }}
                >
                  {val.title}
                </span>
              ))}
</div>

                }
                
                <div className="flex" onClick={() => navigate("/press-releases-chat/history")}>
                  <img
                    src={recentIcon}
                    alt="Campaigns"
                    className="icon-circle"
                    onClick={() => {
                      navigate("/manage-content/add-new-manage-content", {
                        state: { reset: true },
                      });
                    }}
                  />
                  <span className="recent-text">Recent</span>
                </div>
              </div>
              {
                !isAgentUserOrAdmin &&
                <>
                  <div className="blue-heading">
                <p>Inspirations</p>
              </div>
              <div className="lowerSection">
                {/* <img src={assets.images.clockImg} className="icon-circle" /> */}
                {/* {!user?.agentDetails && (
                  <>
                    <div>
                      <img
                        src={assets.images.whatsappImg}
                        className="icon-circle"
                      />
                    </div>

                    <div>
                      <img
                        src={assets.images.crownImg}
                        onClick={() => {
                          navigate("/credits-subscriptions");
                        }}
                        className="icon-circle"
                      />
                    </div>
                  </>
                )} */}
                <div
                  className="flex"
                >
                  <img
                    src={templateIcon}
                    alt="Campaigns"
                    className="icon-circle"
                  />
                  <span>Templates</span>
                </div>
                <div
                  className="flex"
                >
                  <img
                    src={themeIcon}
                    alt="Campaigns"
                    className="icon-circle"
                  />
                  <span>Themes</span>
                </div>
                <div
                  className="flex"
                >
                  <img
                    src={imageIcon}
                    alt="Campaigns"
                    className="icon-circle"
                  />
                  <span>Images</span>
                </div>
              </div>
                </>
              }
              
              </div>
            

              <div className="footerSection">
                <div className="flex">
                  <CustomDropdown
                    isSuperAdminRole={isSuperAdminRole}
                    onClickProfile={onClickProfile}
                    setConfirmationShow={(val: boolean) => setConfirmationShow(val)}
                    showName={false}
                  >
                    <img src={userProfileIcon} alt="Profile" className="icon-circle" />
                  </CustomDropdown>

                  <div className="profile">
                    <p>
                      {user?.firstName ? `${user.firstName}’s WorkSpace` : "My WorkSpace"}
                    </p>
                    {
                      !isAgentUserOrAdmin &&
                      <h6 onClick={() => { navigate("/credits-subscriptions"); }}>Starter</h6>
                    }
                  </div>
                </div>
              </div>


            {/* <div className="borderBottom"></div> */}
            </div>
)}     {typeConfirm?.open && (
          <Confirmation
            show={true}
            onHide={() => setTypeConfirm(null)}
            onConfirmation={() => {
              const ct = typeConfirm?.item;
              handleContentTypeClick(ct);
            }}
            title="Proceed to create content?"
            description={
              isLoading ?
                "Content is being generated for the previous selection. Proceeding will stop the current generation. Do you want to continue?"
                :
                isChatRunning ?
                  "You have an ongoing chat session. Proceeding will end the current session. Do you want to continue?"
                  :
                  ""
            }
            actionBtnName="Yes"
            actionBtnColor="white"
            actionBtnBgColor="#00b8c2"
          />
        )}

      {showConfirmation}  
    </>
  );
};

export default Sidebar;
